document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header'); // Nagłówek
  const menuToggle = document.querySelector('.header__icon--menu'); // Przycisk hamburgera

  // 🚨 BLOK TLA HEADERA USUNIETY (2026-08-11, audyt adversarialny fixu).
  // Historia: blok togglowal `scrolled-past-header` na WEWNETRZNYM `.header`
  // (prog = wysokosc paska ogloszen ~40px), a StickyHeader w header.liquid
  // toggluje TE SAMA klase na WRAPPERZE `.section-header` (prog ~140px) - i to
  // z wrappera czyta ja overlay home (flip kolorow, bialy filtr loga,
  // brand-sneakly-r2.css) oraz na nim polega custom_css bialego tla.
  // Dwa nosniki + dwa progi = pasmo scrollY ~40-140px, w ktorym custom_css
  // malowal biale tlo na .header przy wciaz bialych literach overlaya
  // (niewidzialna nawigacja na home). Od marquee 08-10 blok i tak byl martwy
  // (selektor .announcement-bar = null). Wlascicielem klasy jest WYLACZNIE
  // StickyHeader + initial check w jego IntersectionObserverze (header.liquid).

  // Zmiana tła nagłówka w zależności od stanu menu hamburgerowego
  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        // Jeśli menu jest otwarte
        header.classList.add('menu-open');
      } else {
        // Jeśli menu jest zamknięte
        header.classList.remove('menu-open');
      }
    });
  }
});

/* HOVER-ZDJECIA KART: pobieranie przy pierwszym najechaniu (user 2026-08-13).
   Drugi <img> karty ma data-srcset/data-src zamiast zywych atrybutow - nic sie
   nie pobiera, dopoki kursor nie wjedzie na karte. Gate (hover:hover)+(pointer:
   fine): na dotyku hover nie istnieje, wiec drugie zdjecie NIGDY sie nie laduje
   (decyzja usera: funkcjonalnosc na mobile calkiem wylaczona). mouseover w
   capture na dokumencie = dziala tez dla kart dorenderowanych pozniej. */
/* preload drugiego zdjecia kart USUNIETY 2026-08-28 (user: hover = sam zoom) */

/* Preselekcja filtrow/sortu doklejana przy KLIKU (audyt SEO 2026-08-04).
   href niesie czysty, crawlowalny URL (robots.txt blokuje sort_by i 2x filter),
   a parametry preselekcji z data-snkl-extra dokleja dopiero realny klik -
   klient dostaje dokladnie to samo zachowanie co przed zmiana.
   Middle-click / ctrl+klik / prawy przycisk NIE sa przechwytywane (otworza czysty URL). */
document.addEventListener('click', function (e) {
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  var a = e.target && e.target.closest ? e.target.closest('a[data-snkl-extra]') : null;
  if (!a) return;
  var href = a.getAttribute('href');
  var extra = a.getAttribute('data-snkl-extra');
  if (!href || !extra || href.charAt(0) === '#') return;
  e.preventDefault();
  window.location.href = href + (href.indexOf('?') === -1 ? '?' : '&') + extra;
});
